// Веб-вклад модуля `progress` — прогресс обучения.
//
// Счётчика у пункта нет намеренно: прогресс — не список сущностей, число рядом
// с ним было бы выдуманным.

import { SECTION_ICONS } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const progressWebManifest = {
	id: "progress",
	icon: SECTION_ICONS.progress,
	labelKey: "nav.progress",
	routes: ["/progress"],

	// Баннер объясняет МЕХАНИКУ цифр: они считаются из реальных ответов, а не
	// из отметок «прочитано», и вручную ничего проставлять не нужно. Вкладка
	// справки — «Метод»: прогресс и есть его измеримая часть.
	intro: {
		titleKey: "progress:intro.title",
		bodyKey: "progress:intro.body",
		bulletKeys: [
			"progress:intro.bullets.0",
			"progress:intro.bullets.1",
			"progress:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "progress",
			to: "/progress",
			icon: SECTION_ICONS.progress,
			labelKey: "nav.progress",
			order: 60,
		},
	],
} satisfies WebModuleManifest;
